import cookie from './cookie'
import store from '@/store'
// import router from '@/router'

// 用户是否登录
export function isLogin() {
  return !!cookie('userName') && !!cookie('token')
}

// 转到登录页
export function login(onlogin) {
  store.commit('app/setShowLogin', true)
  store.commit('app/setOnlogin', onlogin)
}

// 清除登录态
export function logout(callback = () => {}) {
  console.log('login out')
  cookie('token', '', { path: '/' })
  cookie('userName', '', { path: '/' })
  cookie('email', '', { path: '/' })
  // store.commit('user/setUserInfo')
  // store.commit('app/upLoginState')
  // store.dispatch('user/logout') // 调用退出登录接口
  callback()
}

// 设置登录态缓存：默认保存 360 天
export function setLoginCookie({ token, userName = '', expires = 360 }) {
  const opts = { expires, path: '/' }
  cookie('token', token, opts)
  cookie('userName', userName, opts)
  store.commit('app/upLoginState') // 更新登录态
  // store.dispatch('app/websocketConnect') // 建立 IM WS 连接
  // store.dispatch('user/getUserid', opts) // 获取并缓存用户 ID
}

// 更新登录态缓存
export function upLoginCookie() {
  if (!isLogin()) return
  setLoginCookie({
    token: cookie('token'),
    userName: cookie('userName'),
  })
}
